/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.5365 6.75 9.4938 2.6646A.75.75 0 0 0 8.823 2.25H2.25A.75.75 0 0 0 1.5 3v3.75h10.0365ZM13.8107 15 9.531 10.7203c-.0003-.0002.0002.0002 0 0-.293-.2929-.7684-.2935-1.0613-.0006a.75.75 0 0 0 0 1.0606l2.4696 2.4697H.75A.75.75 0 0 0 0 15v6c0 1.2426 1.0074 2.25 2.25 2.25h19.5c1.2426 0 2.25-1.0074 2.25-2.25V9c0-1.2426-1.0074-2.25-2.25-2.25h-8.5365l-2.3781-4.7562A2.25 2.25 0 0 0 8.823.75H2.25C1.0074.75 0 1.7574 0 3v5.25h21.75a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75H2.25A.75.75 0 0 1 1.5 21v-5.25h9.4393l-2.4696 2.4697a.75.75 0 0 0 1.0607 1.0606L13.8106 15Z"
    clipRule="evenodd"
  />,
  'Import'
);
